import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Output, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { DtisFooterComponent, DtisRailNavbarComponent, type FooterMeta, type RailBarRouteConfig } from '@dtis/angular';
import { TranslocoModule } from '@jsverse/transloco';
import { select } from '@ngxs/store';
import { SettingsState } from '../../app/states/settings/settings.state';
import { DtisHeaderComponent } from '../dtis-header/dtis-header.component';
import { DtisViewsDrawerComponent } from '../dtis-views-drawer/dtis-views-drawer.component';

@Component({
  selector: 'dtis-shell',
  host: {
    class: 'bg-surface max-w-screen flex h-screen max-h-screen w-screen flex-col items-stretch overflow-hidden',
  },
  imports: [
    RouterModule,
    CommonModule,
    DtisHeaderComponent,
    MatButtonModule,
    DtisFooterComponent,
    DtisRailNavbarComponent,
    MatProgressSpinnerModule,
    MatIconModule,
    TranslocoModule,
    DtisViewsDrawerComponent,
  ],
  template: `  
    <dtis-header [title]="title()" class="flex-none"></dtis-header>
    <main class="flex max-h-full grow overflow-hidden ">
      <dtis-rail-navbar [routes]="railConfig()?.routes ?? []" />
      <dtis-views-drawer>
        <router-outlet></router-outlet>
      </dtis-views-drawer>
    </main>
    <dtis-footer
      class="flex-shrink-0"
      [displayFooterLogo]="true"
      [appVersion]="appVersion()"
      [metadata]="footerMetaConfig()"
      [isAdmin$]="getIsAdmin"
      (toggleDebug)="toggleDebug.emit($event)"
    ></dtis-footer>
  `,
})
export class DtisShellComponent {
  private readonly viewsDrawer = viewChild.required(DtisViewsDrawerComponent);

  /**
   * The title which get passed into the header
   */
  title = input.required<string>();
  /**
   * The current version of the application
   */
  appVersion = input.required<string>();
  /**
   * An Array of keyvalue pairs for the footer
   */
  footerMetaConfig = input<FooterMeta[]>([]);
  /**
   * The configuration for the rail
   */
  railConfig = input<RailBarRouteConfig>();
  /**
   * Observable indicating if the current user has admin privileges.
   */
  isAdmin = select(SettingsState.isAdmin);

  /**
   * the event emitter for the debug button
   */
  @Output() public toggleDebug = new EventEmitter();

  /**
   * Get the admin status as a function for the isAdmin$ input
   */
  getIsAdmin = () => this.isAdmin() || false;

  toggleViewsDrawer() {
    this.viewsDrawer().toggle();
  }
}
